import React from 'react';
import Icon from '~/app/common/Icon';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';
import { useNotificationContext } from '~/app/hooks/useNotificationContext';

export type EmptyMessageComponent = React.FC

const EmptyMessage: EmptyMessageComponent = () => {

    const { isChat } = useNotificationContext();
    const ns = isChat ? "chat" : "notifications";
    const { t } = useTranslation(ns);

    return (
        <div className={classes['message']}>
            <Icon className={classes['icon']} name="forum" size="48"/>
            <div className={classes['title']}>{t('empty')}</div>
            <div className={classes['description']}>{t('emptyMessage')}</div>
        </div>
    );
};

export default EmptyMessage
